import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent } from './FormContent';

export const CompanyContactsSection = () => {
  const { t } = useTranslation();

  return (
    <Section
      datax="companyContactsSection"
      title={t('client.legal.companyContacts.title')}
    >
      <FormContent />
    </Section>
  );
};
